if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this._onViewerNavClick = this._onViewerNavClick.bind(this);
        this._onViewerNavMql = this._onViewerNavMql.bind(this);
        this.bindViewerArrowNav();
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      bindViewerArrowNav() {
        const viewer = this.elements.viewer;
        if (!viewer) return;
        viewer.addEventListener('click', this._onViewerNavClick, true);
        if (this.mql.addEventListener) this.mql.addEventListener('change', this._onViewerNavMql);
        else this.mql.addListener(this._onViewerNavMql);
        requestAnimationFrame(() => this.syncViewerNavButtons());
      }

      _onViewerNavMql() {
        this.syncViewerNavButtons();
      }

      navigableViewerSlides() {
        const viewer = this.elements.viewer;
        if (!viewer) return [];
        return Array.from(viewer.querySelectorAll('.product__media-list > .product__media-item[data-media-id]')).filter(
          (el) => !el.classList.contains('product__media-item--variant')
        );
      }

      syncViewerNavButtons() {
        const layout = this.dataset.desktopLayout || '';
        if (!layout.includes('thumbnail') || !this.mql.matches) return;
        const viewer = this.elements.viewer;
        const prev = viewer && viewer.querySelector('.product-gallery__viewer-nav--prev');
        const next = viewer && viewer.querySelector('.product-gallery__viewer-nav--next');
        if (!prev || !next) return;
        const navigable = this.navigableViewerSlides();
        if (navigable.length < 2) {
          prev.disabled = true;
          next.disabled = true;
          return;
        }
        const idx = Math.max(
          0,
          navigable.findIndex((s) => s.classList.contains('is-active'))
        );
        prev.disabled = idx === 0;
        next.disabled = idx === navigable.length - 1;
      }

      _onViewerNavClick(e) {
        const layout = this.dataset.desktopLayout || '';
        if (!layout.includes('thumbnail') || !this.mql.matches) return;
        const btn = e.target.closest('.product-gallery__viewer-nav');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        const navigable = this.navigableViewerSlides();
        if (navigable.length < 2) return;
        let idx = navigable.findIndex((s) => s.classList.contains('is-active'));
        if (idx < 0) idx = 0;
        const next =
          btn.classList.contains('product-gallery__viewer-nav--next')
            ? idx + 1
            : idx - 1;
        if (next < 0 || next >= navigable.length) return;
        this.setActiveMedia(navigable[next].dataset.mediaId, false);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);
        this.syncViewerNavButtons();

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
